import http from "../../BaseServiceHttp";

class ActionPlanService {
  getActionPlans(factoryId) {
    return http.get(`factories/${factoryId}/action-plans`);
  }
}
export default new ActionPlanService();
